/* eslint-disable no-unused-vars */
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';

const DiscrepancyWarningMsg = (props) => {
  const { discrepancyMsg, handleClose } = props;
  const errorMsgRead = `frr-error-msg-read${uuidv4()}`;
  return (
    <div>
      <div
        className="close-popup-icon frr-close-allocate-btn float-right"
        role="button"
        onClick={() => handleClose(false)}
      >
        <SVGComponent iconName="Icon-cancel-alert" />
      </div>
      {discrepancyMsg.length > 0 ? (
        <div
          className="alert alert-danger custom-alert text-left"
          role="alert"
          aria-describedby={errorMsgRead}
        >
          <div id={errorMsgRead}>
            {discrepancyMsg?.length > 0 &&
              discrepancyMsg?.map((item, index) => {
                return (
                  <div key={item?.id || index}>
                    <span className="frr-label-font d-block mb-2">
                      {item.title}
                    </span>
                    <div>
                      <ul style={{ listStyleType: 'disc' }}>
                        {[
                          ...new Set(
                            item.errorMessagesList?.map((error, errorIndex) => {
                              return (
                                <li key={error || errorIndex}>{`${error}`}</li>
                              );
                            })
                          ),
                        ]}
                      </ul>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      ) : null}
    </div>
  );
};
export default DiscrepancyWarningMsg;
